module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "audio-controls"
  }, [_c('button', {
    staticClass: "hvr-grow",
    attrs: {
      "aria-label": "Reproducir audio"
    },
    on: {
      "click": function($event) {
        _vm.playAudio(_vm.currentId)
      }
    }
  }, [_c('v-icon', [_vm._v("fa fa-play-circle")])], 1), _vm._v(" "), _c('button', {
    staticClass: "hvr-grow",
    attrs: {
      "aria-label": "Pausar audio"
    },
    on: {
      "click": function($event) {
        _vm.pauseAudio()
      }
    }
  }, [_c('v-icon', [_vm._v("fa fa-pause-circle")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d755fc98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/AudioPlayer.vue
// module id = 1050
// module chunks = 1